export const ENABLE_MEMBERSHIP_UI = process.env.NEXT_PUBLIC_ENABLE_MEMBERSHIP_UI === 'true';

export const FEATURE_AUTO_OPEN_APP = process.env.NEXT_PUBLIC_AUTO_OPEN_APP === 'true';

export const FEATURE_CUSTOM_SMART_BANNER_ON_IOS = process.env.NEXT_PUBLIC_CUSTOM_SMART_BANNER_ON_IOS === 'true';

export const ENABLE_RENDERING_INSPECTOR = process.env.NEXT_PUBLIC_ENABLE_RENDERING_INSPECTOR === 'true';

export const IS_LEADERBOARD_ENABLED = process.env.NEXT_PUBLIC_LEADERBOARD_ENABLED === 'true';

export const SITE_INDEXING_ENABLED = process.env.NEXT_PUBLIC_ENABLE_SITE_INDEXING === 'true';
